export const DEFAULT_ADMIN_NOTIFICATION_POLL_MS = 120_000;
export const MIN_ADMIN_NOTIFICATION_POLL_MS = 30_000;

export function resolveAdminNotificationPollMs(
  raw: string | undefined | null,
): number {
  const parsed = raw != null ? Number(raw) : Number.NaN;
  return Number.isFinite(parsed) && parsed >= MIN_ADMIN_NOTIFICATION_POLL_MS
    ? parsed
    : DEFAULT_ADMIN_NOTIFICATION_POLL_MS;
}
